<template>
	<el-row :gutter="20">
		<el-col :span="12">
			<span>类型 ：</span>
			<span>{{row.type}}</span>
		</el-col>
		<el-col :span="12">
			<span>姓名 ：</span>
			<span>{{row.name}}</span>
		</el-col>
		<el-col :span="12">
			<span>房间号 ：</span>
			<span>{{row.roomNumber}}</span>
		</el-col>
		<el-col :span="12">
			<span>联系电话 ：</span>
			<span>{{row.phone}}</span>
		</el-col>
		<el-col :span="12">
			<span>申请时间 ：</span>
			<span>{{setTime(row.createTime)}}</span>
		</el-col>
		<el-col :span="12">
			<span>内容 ：</span>
			<span>{{row.reson}}</span>
		</el-col>
		<el-col :span="12">
			<span>申请类别 ：</span>
			<span>{{row.category}}</span>
		</el-col>

		<el-col :span="24">
			<span style="display: flex;align-items: center;">照片 ：</span>
			<img :src="row.fileName" width="20%">
			<!-- <img :src="row.showPath[0]" width="20%"> -->
		</el-col>
		
	</el-row>
</template>

<script>
	export default{
		props:["row"]
	}
</script>

<style>
</style>
